import { useGetFeaturesSettings } from '@/domain/settings/useCases/useGetFeaturesSettings'
import { useGetWalletDataByCryptoCode } from '@/hooks/useGetWalletDataByCryptoCode'
import type { WalletCurrency } from '@/domain'
import { currencyUtils } from '@/utils'

const { cryptoToFiat } = currencyUtils

export const MAX_WITHDRAW_TYPE = {
  WALLET_BALANCE: 'wallet-balance',
  FEATURE_SETTINGS: 'feature-settings',
} as const

export const useGetMaxAmountToWithdraw = ({
  selectedCryptoWalletData,
}: {
  selectedCryptoWalletData?: WalletCurrency
}) => {
  const usdtWalletData = useGetWalletDataByCryptoCode({
    cryptoCode: 'USDT',
  })
  const { data: featureSettings } = useGetFeaturesSettings()

  const walletFiatAmount = Number(selectedCryptoWalletData?.fiatAmount || 0)
  const maxWithdrawUSDAmount = Number(
    featureSettings?.features?.withdraw?.extra_info?.max_usd_amount || 0,
  )
  const maxWithdrawDisplayAmount = Number(
    cryptoToFiat({
      amountCrypto: maxWithdrawUSDAmount,
      cryptoPricePerUnit: usdtWalletData?.pricePerUnit ?? 0,
    }) || 0,
  )
  const isWithinMaxWithdraw = walletFiatAmount <= maxWithdrawDisplayAmount

  if (maxWithdrawUSDAmount === 0 || isWithinMaxWithdraw) {
    return {
      maxAmount: walletFiatAmount,
      maxType: MAX_WITHDRAW_TYPE.WALLET_BALANCE,
    }
  }

  return {
    maxAmount: maxWithdrawDisplayAmount,
    maxType: MAX_WITHDRAW_TYPE.FEATURE_SETTINGS,
  }
}
